import React from 'react'
import {Container} from "./styles/footer";

export default function Footer({children}){
    return <Container>{children}</Container>
}